import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {ResetPasswordPresenter} from "./resetPasswordPresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class ResetPasswordView extends ViewBase implements IView {

    public _presenter: ResetPasswordPresenter;

    get email() {
        return this.getValueById('email');
    }

    set email(email) {
        this.setValueById('email', email);
    }


    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: ResetPasswordPresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
    }

    setPresenter(resetPasswordPresenter: ResetPasswordPresenter) {
        this._presenter = resetPasswordPresenter;
    }

    render(): void {
    }


}